import { forwardRef, memo } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = (_ref, ref) => {
  let {
    title,
    titleId,
    desc,
    descId,
    ...props
  } = _ref;
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    "aria-hidden": "true",
    width: "1em",
    height: "1em",
    className: "interstate-car-solid-icon",
    ref: ref,
    "aria-labelledby": titleId,
    "aria-describedby": descId,
    ...props,
    children: [desc ? /*#__PURE__*/_jsx("desc", {
      id: descId,
      children: desc
    }) : null, title ? /*#__PURE__*/_jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      d: "M14.541 5.623l-.031-.061h.808a.625.625 0 100-1.25h-1.146a.623.623 0 00-.274.063l-1.115-2.166A2.625 2.625 0 0010.449.786h-4.9c-.983 0-1.884.55-2.334 1.424L2.097 4.383a.622.622 0 00-.29-.071H.66a.625.625 0 100 1.25h.83l-.035.065A2.021 2.021 0 000 7.563v2.667c0 .036 0 .071.002.106v3.143c0 .897.728 1.625 1.625 1.625h1.327c.898 0 1.625-.728 1.625-1.625v-.748h6.849v.748c0 .897.727 1.625 1.625 1.625h1.327c.898 0 1.625-.728 1.625-1.625V10.14H16V7.56a2.02 2.02 0 00-1.459-1.936zm.208 1.897a.777.777 0 00-.871-.723c-1.857.222-4.502.506-5.917.506-1.408 0-4.005-.281-5.837-.502a.777.777 0 00-.873.726l2.312.408a.875.875 0 11-.304 1.724L1.25 9.303v.837h.002v.164A1.25 1.25 0 002.5 11.48h11c.69 0 1.25-.56 1.25-1.25v-.933l-2.03.358a.875.875 0 01-.304-1.724l2.333-.411zm-11.42 5.21H2.5c-.454 0-.88-.12-1.248-.333v1.082c0 .207.168.375.375.375h1.327a.375.375 0 00.375-.375v-.748zm9.349.749v-.748h.822c.457 0 .886-.123 1.255-.338v1.086a.375.375 0 01-.375.375h-1.327a.375.375 0 01-.375-.375zm.459-7.853L11.672 2.78a1.375 1.375 0 00-1.223-.745h-4.9c-.515 0-.987.288-1.223.746L2.861 5.63c1.767.206 3.917.423 5.1.423 1.19 0 3.381-.22 5.176-.427z"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
const Memo = /*#__PURE__*/memo(ForwardRef);

// eslint-disable-next-line react/no-multi-comp
export const CarSolidIcon = /*#__PURE__*/forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx(Memo, {
    ...props,
    ref: ref
  });
});
CarSolidIcon.displayName = 'CarSolidIcon';